import { createSlice } from "@reduxjs/toolkit";
import {
  checkParichayAuthenticityApi,
  dbimsDataApi,
  frameWorkQuestionApi,
  getDBIMManualData,
  getManualData,
  getOverallData,
  getUserSiteApi,
  login,
  loginApi,
  nicLogin,
  parichayLoginUrl,
  parichayLogoutApi,
  postLog,
  refreshApi,
  reportAnswerApi,
  requestApi,
  saveManualDataApi,
  siteDashData,
  checkAuthenticityApi,
  getDbimSurveyQuestions,
  getDbimSurveyAnswers,
  saveDBIMManualDataApi,
  checkLiveReportStatus,
  getDBIMOverallData,
  logoutApiUrl,
  logoutApiAction,
  checkParichayToken,
  fetchReportData,
  checkisReportAlreadyGenerating,
  fetchAdvancedReportData,
} from "../../services/api";

const initialState = {
  data: [],
  isLoading: false,
  isSuccess: false,
  errorMessage: "",
};

export const manualData = createSlice({
  name: "manualData",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getManualData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getManualData.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(getManualData.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const dbimManualData = createSlice({
  name: "manualData/getManualData",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getDBIMManualData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDBIMManualData.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(getDBIMManualData.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const overAllData = createSlice({
  name: "overAllData",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getOverallData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOverallData.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(getOverallData.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const dbimoverAllData = createSlice({
  name: "dbimoverAllData",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getDBIMOverallData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDBIMOverallData.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(getDBIMOverallData.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const initialDashData = createSlice({
  name: "initialDashData",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(siteDashData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(siteDashData.fulfilled, (state, { payload }) => {
        const { data, errorMessage } = payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.data = data;
        state.errorMessage = errorMessage;
      })
      .addCase(siteDashData.rejected, (state, { payload }) => {
        const { errorMessage } = payload;
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = errorMessage;
      });
  },
});

export const refreshDataSlice = createSlice({
  name: "refresh/fetch",
  initialState: {
    isLoading: false,
    isSuccess: false,
    data: [], // Changed from Array to Object
    errorMessage: "",
  },
  reducers: {
    // Custom action to remove a specific slug
    removeRefreshSiteData: (state, action) => {
      const slugToRemove = action.payload;
      state.data = state.data.filter((item) => item.slug !== slugToRemove);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(refreshApi.pending, (state, { meta }) => {
        const { actualSlug: slug } = meta.arg;
        console.log("API Call slug:", slug);
        state.isLoading = true;

        // Check if the slug already exists in the array
        const existingIndex = state.data.findIndex(
          (item) => item.slug === slug
        );

        if (existingIndex === -1) {
          state.data.push({ slug, status: null, error: null });
          console.log("Reacheddd in push State- refresh api", state.data);
        }
      })
      .addCase(refreshApi.fulfilled, (state, { payload }) => {
        const { slug, data } = payload;
        state.isLoading = false;
        state.isSuccess = true;

        // Update the entry for the specific slug
        const existingIndex = state.data.findIndex(
          (item) => item.slug === slug
        );
        if (existingIndex !== -1) {
          state.data[existingIndex] = { ...state.data[existingIndex], ...data };
        } else {
          state.data.push({ slug, ...data });
        }
      })
      .addCase(refreshApi.rejected, (state, { payload, meta }) => {
        const slug = payload?.slug || meta.arg.actualSlug;
        const error = payload?.error || "Unknown error";
        state.isLoading = false;
        state.isSuccess = false;

        // Update the error for the specific slug
        const existingIndex = state.data.findIndex(
          (item) => item.slug === slug
        );
        if (existingIndex !== -1) {
          state.data[existingIndex].error = error;
        } else {
          state.data.push({ slug, status: null, error });
        }
      });
  },
});

export const requestDataSlice = createSlice({
  name: "request/fetch",
  initialState: {
    isLoading: false,
    isSuccess: false,
    data: [], // Changed from Array to Object
    errorMessage: "",
  },
  reducers: {
    // Custom action to remove a specific slug
    removeRequestSiteData: (state, action) => {
      const slugToRemove = action.payload;
      state.data = state.data.filter((item) => item.slug !== slugToRemove);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestApi.pending, (state, { meta }) => {
        const { actualSlug: slug } = meta.arg;
        state.isLoading = true;

        const existingIndex = state.data.findIndex(
          (item) => item.slug === slug
        );
        if (existingIndex === -1) {
          state.data.push({ slug, status: null, error: null });
        }
      })
      .addCase(requestApi.fulfilled, (state, { payload }) => {
        const { slug, data } = payload;
        state.isLoading = false;
        state.isSuccess = true;

        const existingIndex = state.data.findIndex(
          (item) => item.slug === slug
        );
        if (existingIndex !== -1) {
          state.data[existingIndex] = { ...state.data[existingIndex], ...data };
        } else {
          state.data.push({ slug, ...data });
        }
      })
      .addCase(requestApi.rejected, (state, { payload, meta }) => {
        const slug = payload?.slug || meta.arg.actualSlug;
        const error = payload?.error || "Unknown error";
        state.isLoading = false;
        state.isSuccess = false;

        const existingIndex = state.data.findIndex(
          (item) => item.slug === slug
        );
        if (existingIndex !== -1) {
          state.data[existingIndex].error = error;
        } else {
          state.data.push({ slug, status: null, error });
        }
      });
  },
});

export const reportAnswerSlice = createSlice({
  name: "reportAnswer",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(reportAnswerApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(reportAnswerApi.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(reportAnswerApi.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const dashloginSlice = createSlice({
  name: "nic/login",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(nicLogin.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(nicLogin.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(nicLogin.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const postLogSlice = createSlice({
  name: `login/postLog`,
  initialState,
  reducers: {
    resetPostLogState: () => initialState, // Reset state to initial
  },
  extraReducers: (builder) => {
    builder
      .addCase(postLog.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postLog.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(postLog.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const switchSiteSlice = createSlice({
  name: `getSites`,
  initialState,
  reducers: {
    resetSiteData: (state, payload) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.data = payload; // Reset state to initial
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserSiteApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUserSiteApi.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(getUserSiteApi.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const excelReportSlice = createSlice({
  name: `excelReportSlice`,
  initialState: {
    data: [],
    isLoading: false,
    isSuccess: false,
    errorMessage: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReportData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchReportData.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(fetchReportData.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const advancedExcelReportSlice = createSlice({
  name: "fetchAdvancedReportData",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdvancedReportData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAdvancedReportData.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(fetchAdvancedReportData.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const logoutSlice = createSlice({
  name: `logoutApiAction`,
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(logoutApiAction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(logoutApiAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(logoutApiAction.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const frameWorkSlice = createSlice({
  name: `framework`,
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(frameWorkQuestionApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(frameWorkQuestionApi.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(frameWorkQuestionApi.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const dbimsDataSlice = createSlice({
  name: "dbimsData",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(dbimsDataApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(dbimsDataApi.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(dbimsDataApi.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const loginReducer = createSlice({
  name: "loginApi",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(loginApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(loginApi.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(loginApi.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const parichayUrlReducer = createSlice({
  name: `parichayLoginUrl`,
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(parichayLoginUrl.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(parichayLoginUrl.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(parichayLoginUrl.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const saveManualDataReducer = createSlice({
  name: `saveManualDataApi`,
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(saveManualDataApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(saveManualDataApi.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(saveManualDataApi.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const saveDBIMDataReducer = createSlice({
  name: `saveDBIMManualDataApi`,
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(saveDBIMManualDataApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(saveDBIMManualDataApi.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(saveDBIMManualDataApi.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const parichay_logoutReducer = createSlice({
  name: `parichayLogoutApi`,
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(parichayLogoutApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(parichayLogoutApi.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(parichayLogoutApi.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const parichayAuthenticReducer = createSlice({
  name: `checkParichayAuthenticityApi`,
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(checkParichayAuthenticityApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(checkParichayAuthenticityApi.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(checkParichayAuthenticityApi.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const checkAuthenticUserReducer = createSlice({
  name: `checkAuthenticityApi`,
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(checkAuthenticityApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(checkAuthenticityApi.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(checkAuthenticityApi.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const getDbimSurveyAnswersReducer = createSlice({
  name: `getDbimSurveyQuestions`,
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getDbimSurveyAnswers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDbimSurveyAnswers.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(getDbimSurveyAnswers.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const getLiveReportStatus = createSlice({
  name: `checkLiveReportStatus`,
  initialState: {
    isLoading: false,
    isSuccess: false,
    data: [], // Using an array to store multiple entries
    errorMessage: "",
  },
  reducers: {
    // Custom action to remove a specific slug
    removeSiteCheckData: (state, action) => {
      const slugToRemove = action.payload;
      state.data = state.data.filter((item) => item.slug !== slugToRemove);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkLiveReportStatus.pending, (state, { meta }) => {
        const { actualSlug: slug } = meta.arg;
        state.isLoading = true;

        // Check if the slug already exists in the array
        const existingIndex = state.data.findIndex(
          (item) => item.slug === slug
        );
        if (existingIndex === -1) {
          state.data.push({ slug, status: null, error: null });
        }
      })
      .addCase(checkLiveReportStatus.fulfilled, (state, { payload }) => {
        const { slug, data } = payload;
        state.isLoading = false;
        state.isSuccess = true;

        // Update the entry for the specific slug
        const existingIndex = state.data.findIndex(
          (item) => item.slug === slug
        );
        if (existingIndex !== -1) {
          state.data[existingIndex] = { ...state.data[existingIndex], ...data };
        } else {
          state.data.push({ slug, ...data });
        }
      })
      .addCase(checkLiveReportStatus.rejected, (state, { payload, meta }) => {
        const slug = payload?.slug || meta.arg.actualSlug;
        const error = payload?.error || "Unknown error";
        state.isLoading = false;
        state.isSuccess = false;

        // Update the error for the specific slug
        const existingIndex = state.data.findIndex(
          (item) => item.slug === slug
        );
        if (existingIndex !== -1) {
          state.data[existingIndex].error = error;
        } else {
          state.data.push({ slug, status: null, error });
        }
      });
  },
});

export const fetchParichayToken = createSlice({
  name: "checkParichayToken",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(checkParichayToken.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(checkParichayToken.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload;
      })
      .addCase(checkParichayToken.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      });
  },
});

export const fetchSiteStatusReducer = createSlice({
  name: "checkisReportAlreadyGenerating",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(checkisReportAlreadyGenerating.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(
        checkisReportAlreadyGenerating.fulfilled,
        (state, { payload }) => {
          state.isLoading = false;
          state.isSuccess = true;
          state.data = payload;
        }
      )
      .addCase(
        checkisReportAlreadyGenerating.rejected,
        (state, { payload }) => {
          state.isLoading = false;
          state.isSuccess = false;
          state.errorMessage = payload;
        }
      );
  },
});

export const manualDataReducer = manualData.reducer;
export const excelReportDataReducer = reportAnswerSlice.reducer;
export const advancedExcelReportReducer = advancedExcelReportSlice.reducer;
export const initialDashDataReducer = initialDashData.reducer;
export const refreshDataReducer = refreshDataSlice.reducer;
export const requestDataReducer = requestDataSlice.reducer;
export const reportAnswerReducer = reportAnswerSlice.reducer;
export const dashloginSliceReducer = dashloginSlice.reducer;
export const postLogReducer = postLogSlice.reducer;
export const switchSiteReducer = switchSiteSlice.reducer;
export const frameWorkSliceReducer = frameWorkSlice.reducer;
export const dbimsDataSliceReducer = dbimsDataSlice.reducer;
export const loginDataReducer = loginReducer.reducer;
export const parichayUrlDataReducer = parichayUrlReducer.reducer;
export const postManualDataReducer = saveManualDataReducer.reducer;
export const overAllDataReducer = overAllData.reducer;
export const getDBIMDataReducer = dbimManualData.reducer;
export const parichayLogoutReducer = parichay_logoutReducer.reducer;
export const parichayAuthenticationReducer = parichayAuthenticReducer.reducer;
export const checkUserAuthenticityReducer = checkAuthenticUserReducer.reducer;
export const checkParichayAuth = fetchParichayToken.reducer;
export const checkSiteStatus = fetchSiteStatusReducer.reducer;
export const fetchDbimSurveyQuestionsReducer =
  getDbimSurveyAnswersReducer.reducer;
export const postDbimSurveyReducer = saveDBIMDataReducer.reducer;
export const checkLiveReportStatusReducer = getLiveReportStatus.reducer;
export const fetchdbimoverAllData = dbimoverAllData.reducer;
export const logoutUserReducer = logoutSlice.reducer;
export const { resetSiteData } = switchSiteSlice.actions;
export const { resetPostLogState } = postLogSlice.actions;

export const { removeRefreshSiteData } = refreshDataSlice.actions;

export const { removeRequestSiteData } = requestDataSlice.actions;
export const { removeSiteCheckData } = getLiveReportStatus.actions;
